import { readFragment, ResultOf } from "gql.tada";
import { TitleSectionById } from "../../queries/entries/TitleSectionById";
import { useScroll, useTransform } from "motion/react";
import { useRef } from "react";
import { motion } from "motion/react";
import { AnimatedSplitLines } from "../shared/AnimatedSplitLines";
import { TitleSectionFragment } from "../../queries/fragments/TitleSectionFragment";
import { Button } from "../shared/core/Button";
import { LinkFragment } from "../../queries/fragments/LinkFragment";
import { Link } from "../shared/core/Link";
import { MarkdownLite } from "../shared/MarkdownLite";

export const TitleSection = ({
  entry: { titleSection },
}: {
  entry: ResultOf<typeof TitleSectionById>;
}) => {
  const entry = readFragment(TitleSectionFragment, titleSection);
  const sectionRef = useRef<HTMLElement>(null);
  const { scrollYProgress } = useScroll({
    target: sectionRef,
    offset: ["start end", "end start"],
  });
  const altTextOpacity = useTransform(
    scrollYProgress,
    [0, 0.25, 0.4, 0.6, 1],
    [0, 0, 1, 1, 0]
  );
  const titleSplitLinesMv = useTransform(
    scrollYProgress,
    [0, 0.4, 0.6, 1],
    [1, 0, 0, 0]
  );

  if (!entry) return null;

  const link = readFragment(LinkFragment, entry.cta);

  return (
    entry.title && (
      <section
        ref={sectionRef}
        className="flex flex-col justify-center gap-5 dsk:gap-16 text-center text-balance dsk:px-20 py-32"
      >
        {entry.superText && (
          <motion.p
            style={{ opacity: altTextOpacity }}
            className="text-body-small"
          >
            <MarkdownLite>{entry.superText}</MarkdownLite>
          </motion.p>
        )}
        <h2 className="text-display text-center">
          <AnimatedSplitLines key={entry.sys.id} value={titleSplitLinesMv}>
            <MarkdownLite>{entry.title}</MarkdownLite>
          </AnimatedSplitLines>
        </h2>
        {entry.subText && (
          <motion.p
            style={{ opacity: altTextOpacity }}
            className="text-body-large"
          >
            <MarkdownLite>{entry.subText}</MarkdownLite>
          </motion.p>
        )}
        {link && (
          <div>
            <Button asChild>
              <Link link={link}>{link?.text}</Link>
            </Button>
          </div>
        )}
      </section>
    )
  );
};
